<template>
  <!-- 语言集训营-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo22" :type="'yyjzy'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo22 from '@/assets/images/logo22.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo22
    }
  }
}
</script>